import { __ } from "src/libs/utilities"
import FieldInput from ".."
import IScalarForm, { SCALAR_TYPES } from "../interface/IScalarForm"
import Scalar from "./Scalar"
import { BORDER_STYLE } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */ 
const Border = (props: IScalarForm): JSX.Element => {
    return <Scalar 
        { ...props } 
        rowClassName="width-auto"
        enabledForm={<BorderEnabled {...props} />}
        desabledForm={<BorderDisabled {...props} />}
    />
}
export default Border

export const BorderEnabled = (props: IScalarForm): JSX.Element => {
    const onChange = (value: any) => {  
        if( props.onChange )
        {
            props.onChange( value,  props.field, "" )
        }   
    }
    const onValueChange = ( value: any, field:string ) => {
        onChange({ ...props.value, [field]: value })
    }

    return <div className="m-1 p-3 bg-contrast-secondary-opacity w-100">
        <div style={{
            width: 35,
            height: 35,
            margin: 10,
            borderColor: props.value?.borderColor,
            borderStyle: props.value?.borderStyle   || BORDER_STYLE.SOLID,
            borderWidth: props.value?.borderWidth   || 0, 
            borderRadius: props.value?.borderRound?.border || 2,
        }} className="bg-contrast-secondary-opacity" />
        <FieldInput
            subtitle={__("Width")}
            field="borderWidth"
            type={SCALAR_TYPES.NUMBER}
            default={1}
            onChange={onValueChange}
            value={props.value?.borderWidth}
            notClear
            editable
        />
        <FieldInput
            subtitle={__("Color")}
            rowClassName="ml-1"
            field="borderColor"
            type={SCALAR_TYPES.COLOR}
            onChange={onValueChange}
            value={props.value?.borderColor}
            notClear
            editable
        />
        <FieldInput
            subtitle={__("Style")}
            rowClassName="ml-1"
            field="borderStyle"
            type={SCALAR_TYPES.TAGS}
            values={ Object.values( BORDER_STYLE ).map( (v:string) => ({ _id: v, title: __(v) }) ) }
            onChange={onValueChange}
            value={props.value?.borderStyle}
            default={BORDER_STYLE.SOLID}
            notClear
            editable
        />
        <FieldInput
            subtitle={__("Border radius")}
            rowClassName="ml-1"
            field="borderRound"
            type={SCALAR_TYPES.BORDER_RADIUS} 
            onChange={onValueChange}
            value={props.value?.borderRound}
            default={0}
            max={200}
            notClear
            editable
        />
    </div>
}
export const BorderDisabled = (props: IScalarForm): JSX.Element => {
    return <>BORDER</>
}